import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonApiService } from '../../../common-api.service';
import { SpeakerService } from '../../../speaker.service';
import { SnackbarService } from '../../../snackbar.service';
import { CommonDropdownService } from '../../../common-dropdown.service';
import { PaginatedDropdown } from '../../../util/paginated-dropdown';
import { validateRequired } from '../../../util/validation.util';

@Component({
  selector: 'app-job-order-log',
  templateUrl: './job-order-log.component.html',
  styleUrls: ['./job-order-log.component.css']
})
export class JobOrderLogComponent implements OnInit, OnDestroy {

  public allListJobs: any[] = [];
  public job: PaginatedDropdown;

  displayColumns = [
    'process',
    'type',
    'time',
    'employee',
    'rework_process',
  ];
  displayHeaders = [
    'Process Name',
    'Type',
    'Time',
    'Employee',
    'Rework Process',
  ];

  constructor(
    public speaker: SpeakerService,
    private api: CommonApiService,
    private snackbar: SnackbarService,
    private dropdownService: CommonDropdownService,
  ) {
    this.job = new PaginatedDropdown(this.api, this.dropdownService, 'joborder');
  }

  ngOnInit(): void {
    this.speaker.listData = this.allListJobs;
    this.job.init();
  }

  ngOnDestroy(): void {
    this.job.destroy();
  }

  getReportDetails(data: any) {
    this.speaker.isLoading = true;
    this.api.callRoute('joborder', '/production/log', data).subscribe({
      next: (res) => {
        this.speaker.isLoading = false;
        if (res?.status == false) {
          this.snackbar.info(res.message);
        } else {
          this.allListJobs = res;
          this.speaker.listData = this.allListJobs;
        }
      },
      error: () => { this.speaker.isLoading = false; }
    });
  }

  generateReport() {
    if (!validateRequired(
      [{ value: this.job.selectedId, label: 'Job', allowZero: false }],
      this.snackbar,
    )) {
      return;
    }
    const data = {
      job_id: this.job.selectedId,
    };
    this.speaker.listData = [];
    this.getReportDetails(data);
    this.speaker.model = 'joborder';
    this.speaker.displayColumns = this.displayColumns;
    this.speaker.displayHeaders = this.displayHeaders;
  }
}
